import React, { useEffect } from "react";

export default function RedirectToPdf({ pdfPath }) {
  useEffect(() => {
    window.location.replace(pdfPath);
  }, [pdfPath]);

  return null;
}
